import { Form } from "react-bootstrap";
import PropTypes from 'prop-types';
import { PERIODS } from './periodUtils';

function PeriodFilter({ selectedPeriod, onPeriodChange }) {

  return (
    <div className="d-flex align-items-center mb-4">
      <i className="bi bi-calendar3 me-2" style={{ fontSize: "1.5rem", color: "#6c757d" }}></i>
      <span className="me-3" style={{ fontWeight: "500", color: "#495057" }}>Período:</span>
      <Form.Select
        value={selectedPeriod}
        onChange={(e) => onPeriodChange(e.target.value)}
        style={{ 
          maxWidth: "250px",
          cursor: "pointer",
          borderColor: "#dee2e6"
        }}
      >
        {PERIODS.map((period) => (
          <option key={period.value} value={period.value}>
            {period.label}
          </option>
        ))}
      </Form.Select>
    </div>
  );
}

PeriodFilter.propTypes = {
  selectedPeriod: PropTypes.string.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
};

export default PeriodFilter;
